// NOTICE: KAPTION-INTEGRATION
// Asistentes (agent providers): Resumen, Sets, Configuración and the
// Salesforce Agentforce page with its tabs (Herramientas and Pruebas need
// KAPTION_AGENTFORCE_MANAGEMENT). Administrators only, like the other
// settings pages (the API enforces the same). The flags are checked by the
// layouts, which render a "not enabled" state instead of bouncing the admin on
// a cold flag cache (same approach as the Calls workspace).
import { frontendURL } from '../../../helper/URLHelper';
import { KAPTION_ASSISTANTS_ROUTES } from 'dashboard/components-next/sidebar/kaptionAssistantsSidebar';

const KaptionAssistantsLayout = () => import('./KaptionAssistantsLayout.vue');
const KaptionAssistantsOverviewPage = () =>
  import('./pages/KaptionAssistantsOverviewPage.vue');
const KaptionAssistantsSettingsPage = () =>
  import('./pages/KaptionAssistantsSettingsPage.vue');
const KaptionAgentforceLayout = () =>
  import('./pages/agentforce/KaptionAgentforceLayout.vue');
const KaptionAgentforceConnectionPage = () =>
  import('./pages/agentforce/KaptionAgentforceConnectionPage.vue');
const KaptionAgentforceBehaviorPage = () =>
  import('./pages/agentforce/KaptionAgentforceBehaviorPage.vue');
const KaptionAgentforceActivityPage = () =>
  import('./pages/agentforce/KaptionAgentforceActivityPage.vue');
const KaptionAgentforceToolsPage = () =>
  import('./pages/agentforce/KaptionAgentforceToolsPage.vue');
const KaptionAgentforceTestsPage = () =>
  import('./pages/agentforce/KaptionAgentforceTestsPage.vue');
const KaptionAssistantsSetsPage = () =>
  import('./pages/sets/KaptionAssistantsSetsPage.vue');

const meta = { permissions: ['administrator'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/assistants'),
    component: KaptionAssistantsLayout,
    meta,
    children: [
      {
        path: '',
        name: KAPTION_ASSISTANTS_ROUTES.OVERVIEW,
        meta,
        component: KaptionAssistantsOverviewPage,
      },
      {
        path: 'settings',
        name: KAPTION_ASSISTANTS_ROUTES.SETTINGS,
        meta,
        component: KaptionAssistantsSettingsPage,
      },
      {
        path: 'sets',
        name: KAPTION_ASSISTANTS_ROUTES.SETS,
        meta,
        component: KaptionAssistantsSetsPage,
      },
      {
        path: 'agentforce',
        name: KAPTION_ASSISTANTS_ROUTES.AGENTFORCE,
        meta,
        component: KaptionAgentforceLayout,
        redirect: to => ({
          name: KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_CONNECTION,
          params: to.params,
        }),
        children: [
          {
            path: 'connection',
            name: KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_CONNECTION,
            meta,
            component: KaptionAgentforceConnectionPage,
          },
          {
            path: 'behavior',
            name: KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_BEHAVIOR,
            meta,
            component: KaptionAgentforceBehaviorPage,
          },
          {
            path: 'tools',
            name: KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_TOOLS,
            meta,
            component: KaptionAgentforceToolsPage,
          },
          {
            path: 'tests',
            name: KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_TESTS,
            meta,
            component: KaptionAgentforceTestsPage,
          },
          {
            path: 'activity',
            name: KAPTION_ASSISTANTS_ROUTES.AGENTFORCE_ACTIVITY,
            meta,
            component: KaptionAgentforceActivityPage,
          },
        ],
      },
    ],
  },
];
